import { useEffect, useRef, useSyncExternalStore } from 'react';

/**
 * Открытые слои (шторки), которые «назад» закрывает раньше, чем уводит
 * с экрана. Верхний — последний открытый.
 */
const layers: Array<{ close: () => void }> = [];
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getOpenCount() {
  return layers.length;
}

/** Закрывает верхний слой. false — закрывать нечего */
export function closeTopLayer(): boolean {
  const top = layers[layers.length - 1];
  if (!top) return false;
  top.close();
  return true;
}

export function useOpenLayersCount(): number {
  return useSyncExternalStore(subscribe, getOpenCount);
}

export function useCloseOnBack(active: boolean, onClose: () => void) {
  // Обработчик у шторок обычно новый на каждый рендер: держим свежий,
  // не переставляя слой в стеке
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!active) return;

    const layer = { close: () => onCloseRef.current() };
    layers.push(layer);
    notify();

    return () => {
      const index = layers.indexOf(layer);
      if (index !== -1) layers.splice(index, 1);
      notify();
    };
  }, [active]);
}
